import { Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';
import CloseIcon from '@mui/icons-material/Close';

const useStyles = makeStyles({
    divContent: {
        flex: 1,
        marginTop: '20px',
        marginBottom: '20px',

    },
    divImageFullScreen: {
        width: '45%',
        resizeMode: 'contain',
    },
    closeIcon: {
        marginTop: '20px',
        marginBottom: '20px',
        cursor: 'pointer'
    },

});

const ImageFullScreenComponent = ({ uri, handleClose }) => {
    const classes = useStyles();

    return (
        <Grid container className={classes.divContent}>
            <Grid size={12}>
                <CloseIcon
                    onClick={handleClose}
                    className={classes.closeIcon}
                    fontSize='small'
                />
            </Grid>
            <Grid>
                <img
                    className={classes.divImageFullScreen}
                    alt=""
                    src={uri}
                />
            </Grid>
        </Grid>
    );
}

export default ImageFullScreenComponent;